import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import {
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from '@mui/material';
import { Add, Close } from '@mui/icons-material';
import { LocalizationProvider, MobileDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useFormStyles } from '../../styles/useFormStyles';

export const FormMultiDateTimePicker = observer(
  ({ processedValues, name, updateInputValue, label }: any) => {
    const formClasses = useFormStyles();
    const [openPicker, setOpenPicker] = useState(false);
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);

    const handleAddDate = () => {
      setOpenPicker(true);
    };

    const formatDateTime = (date: Date) => {
      const formatter = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
      const parts = formatter.formatToParts(date);
      const day = parts.find((p) => p.type === 'day')?.value;
      const month = parts.find((p) => p.type === 'month')?.value;
      const year = parts.find((p) => p.type === 'year')?.value;
      const hour = parts.find((p) => p.type === 'hour')?.value;
      const minute = parts.find((p) => p.type === 'minute')?.value;

      return `${day}.${month}.${year} at ${hour}:${minute}`;
    };

    const handleAccept = () => {
      if (selectedDate) {
        const formattedDate = formatDateTime(selectedDate);
        const updatedList = processedValues[name]
          ? [...processedValues[name], formattedDate]
          : [formattedDate];
        updateInputValue(updatedList, name);
        setOpenPicker(false);
        setSelectedDate(null);
      }
    };

    const handleRemoveDate = (index: number) => {
      const updatedList = processedValues[name]?.filter((_: any, i: number) => i !== index);
      updateInputValue(updatedList, name);
    };

    const handleDateChange = (newDate: Date | null) => {
      setSelectedDate(newDate);
    };

    return (
      <div className={formClasses.formDrawerInput}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <TextField
            label={label}
            variant="outlined"
            fullWidth
            InputProps={{
              readOnly: true,
            }}
          />
          <IconButton onClick={handleAddDate} color="primary">
            <Add />
          </IconButton>
        </div>
        <hr />

        <div className={formClasses.formDrawerInput} style={{ display: 'flex' }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDateTimePicker
              open={openPicker}
              value={selectedDate}
              onChange={handleDateChange}
              onAccept={handleAccept}
              onClose={() => setOpenPicker(false)}
              renderInput={(params) => <TextField {...params} style={{ display: 'none' }} />}
              DialogProps={{
                disablePortal: true,
              }}
            />
          </LocalizationProvider>

          <List>
            {processedValues[name]?.map((date: string, index: number) => (
              <ListItem key={index}>
                <ListItemText primary={date} />
                <ListItemSecondaryAction>
                  <IconButton edge="end" onClick={() => handleRemoveDate(index)}>
                    <Close />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </div>
      </div>
    );
  },
);
